import { trim } from 'ramda';

export default html => trim(html.replace(/(<([^>]+)>)/ig, '').replace('&nbsp;', ''));
